import { render } from "./tag-select.vue?vue&type=template&id=47a08ff2&lang=pug"
import script from "./tag-select.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-select.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__